(function (window, document) {
  ('use strict');

  let logger = {},
    tickers = document.querySelectorAll('.vodl-tickaroo__ticker.pre-init'),
    scriptInitialized = false;

  const initTickaroo = (ticker) => {
    ticker.classList.remove('pre-init');
    let tickerError = ticker.querySelector('.tik4-load-error__content') || false;
    let placeholder = ticker.parentNode.querySelector('.vodl-tickaroo__placeholder');

    if (tickerError) {
      logger.log('initTickaroo(): there\'s an error!', tickerError);
      placeholder.innerHTML = tickerError.innerHTML;
      return;
    }

    let datenow = new Date();
    let maxTime = ticker.dataset.maxTime || 120; // in minutes.
    let tickerItem = ticker.querySelector('.tik4-event') || false;

    // No events.
    if (!tickerItem) {
      return;
    }

    let tickerItemTime = tickerItem.querySelector('time.tik4-meta__ts') || false;

    let diff = datenow.getTime() - new Date(tickerItemTime.getAttribute('datetime')).getTime();
    let minutes = Math.floor(diff / 1000 / 60);

    logger.log('initTickaroo() - latest entry ' + minutes + ' minutes ago');

    if (maxTime > minutes || tickerItem.classList.contains('tik4-event--pin')) {
      placeholder.style.display = 'none';
      ticker.style.display = 'block';
    } else {
      // No events within the time frame.
      let placeholderNoEntry = placeholder.dataset.noEntry || 'Derzeit gibt es keine aktuellen Verkehrsmeldungen.';
      placeholder.innerHTML = placeholderNoEntry;
      return;
    }

    // Add click event handler to forward to event on tickerpage
    // only if there's a moreLink set.
    if (!ticker.dataset.hasOwnProperty('moreLink')) {
      logger.log('There\'s no link to forward to, so no clickable events.');
      return;
    }
    let items = ticker.querySelectorAll('.tik4-event');
    let moreLink = ticker.dataset.moreLink;

    items.forEach((item) => {
      item.addEventListener('click', (e) => {
        let eventid = item.dataset.tickarooEventId;
        window.location = moreLink + '?eventid=' + eventid;
      });
    });
  };

  try {
    logger = new window.RussMedia.Utils.Logger('[tik] ') || {
      log: function () {},
    };
  } catch (e) {
    logger = { log: function () {} };
  }

  // Init ticker when tickaroo script was intialized.
  tickers.forEach((ticker) => {
    ticker.addEventListener('tickarooLiveblogInit', (e) => {
      initTickaroo(ticker);
    });
  });

  // Init tickaroo script.
  const initTickarooScript = () => {
    tickers = document.querySelectorAll('.vodl-tickaroo__ticker.pre-init');

    if (0 === tickers.length || scriptInitialized) {
      return;
    }

    scriptInitialized = true;
    const ticker = tickers.item(0);
    logger.log('initTickarooScript for ' + tickers.length + ' tickers');

    let tickerScript = ticker.dataset.src;
    if (ticker && tickerScript) {
      let newScriptTag = document.createElement('script');
      newScriptTag.async = true;
      newScriptTag.src = tickerScript;

      ticker.appendChild(newScriptTag);
    }
  };

  document.addEventListener('DOMContentLoaded', (e) => {
    logger.log('DOMContentLoaded');
    initTickarooScript();
  });

  window.addEventListener('newPage', (e) => {
    logger.log('newPage');
    initTickarooScript();
  });
})(window, document);
